function LensItem({ item }) {
    return (
        <div className="border-t border-[#EAEAEA] flex items-center">
            <div className="w-[48%] p-[6px_10px_6px_16px] flex items-center gap-2">
                {
                    item?.imageUrls && item?.imageUrls?.length > 0 && 
                    <img className='size-16 rounded-[5.5px] object-cover' src={item.imageUrls[0]} alt={item?.postTitle} />
                }

                {
                    item?.videoUrls && 
                    <video className='size-16 rounded-[5.5px] object-cover' src={item.videoUrls} />
                }

                <h1 className='w-[calc(100%-64px)] whitespace-nowrap overflow-hidden text-ellipsis text-[#121212] font-semibold text-[14px] leading-6'>{item?.postTitle}</h1>
            </div>

            <div className="w-[13%] px-[10px] py-[18px]">
                <h2 className='font-medium text-[14px] leading-6 text-[#121212]'>-</h2>
            </div>

            <div className="w-[13%] px-[10px] py-[18px]">
                <h2 className='font-medium text-[14px] leading-6 text-[#121212]'>{item.noOflikes}</h2>
            </div>

            <div className="w-[13%] px-[10px] py-[18px]">
                <h2 className='font-medium text-[14px] leading-6 text-[#121212]'>-</h2>
            </div>

            <div className="w-[13%] px-[10px] py-[18px]">
                <h2 className='font-medium text-[14px] leading-6 text-[#121212]'>-</h2>
            </div>
        </div>
    );
}

export default LensItem;
